<template>
  <IconButton :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/exit-to-app.svg')">
    返回
  </IconButton>
</template>

<script>
import IconButton from './IconButton'

export default {
  components: {
    IconButton,
  },
}
</script>

<style lang="scss" module>
.button {
  @apply flex;
  @apply items-center;
}

.text {
  font-size: 1.6rem;
}
</style>
